import React from 'react';
import { useTranslation } from 'react-i18next';

const MOSCOW_ORDER = ['MUST', 'SHOULD', 'COULD', 'WONT'] as const;

interface MoscowSegmentedBarProps {
  value: string | null | undefined;
}

const MoscowSegmentedBar: React.FC<MoscowSegmentedBarProps> = ({ value }) => {
  const { t } = useTranslation();

  return (
    <div className="space-y-1">
      <div className="flex w-full rounded-lg overflow-hidden border border-border bg-muted/50">
        {MOSCOW_ORDER.map((key) => {
          const isSelected = value === key;
          return (
            <div
              key={key}
              className={`flex-1 min-w-0 py-2 px-1 text-center text-xs font-medium border-r border-border last:border-r-0 ${
                isSelected
                  ? 'bg-primary text-primary-foreground'
                  : 'text-muted-foreground bg-muted/30'
              }`}
              title={t(`qualification.form.moscow.${key}`)}
            >
              <span className="truncate block">{t(`qualification.form.moscow.${key}`)}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default MoscowSegmentedBar;
